import { useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  setSubpage,
  setMultiGroupIds,
  setMultiLocationIds,
} from 'redux/reducers/meteorologyAgroTrackingForecastDetailedViewControlPanelReducer';
import { store } from 'redux/store';

export default function useRedirectFromMap() {
  const { state } = useLocation();

  useEffect(() => {
    if (!state) return;

    if (state.subpage) {
      store.dispatch(setSubpage(state.subpage));
    }
    if (state.multiGroupIds) {
      store.dispatch(setMultiGroupIds(state.multiGroupIds));
    }
    if (state.multiLocationIds) {
      store.dispatch(setMultiLocationIds(state.multiLocationIds));
    }
  }, [state]);
}
